





import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IPolicy, PolicyStatus } from 'admiral-core';
import { Util } from '@/utils/Util';

@Component({
  name: 'policy-status-badge',
  components: {},
})
export default class PolicyStatusBadge extends Vue {
  @Prop({ required: false, type: Object })
  policy!: IPolicy;

  @Prop({ required: false, type: String })
  policyStatus!: PolicyStatus;

  @Prop({ required: false, type: Boolean, default: false })
  short!: boolean;

  get status() {
    return this.policy ? this.policy.status : this.policyStatus;
  }

  get label() {
    const l = Util.formatPolicyStatus(this.status);
    return this.short ? l.substr(0, 1) : l;
  }

  get clazz() {
    return Util.formatPolicyStatusClass(this.status);
  }
}
